module.exports = __webpack_public_path__ + "static/media/search.18712ca8.svg";